import { useEffect } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const ConfirmDialog = ({
  isOpen,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isLoading = false,
  onConfirm,
  onClose,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && !isLoading) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, isLoading, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Close dialog"
        className="absolute inset-0 !bg-[#130705]/40 !p-0 !shadow-none hover:!bg-[#130705]/40 hover:!shadow-none"
        onClick={isLoading ? undefined : onClose}
        disabled={isLoading}
      />

      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        className="relative z-10 w-full max-w-md rounded-lg border border-[#e4d9c8] bg-white p-6 shadow-[0_20px_50px_rgba(19,7,5,0.12)]"
      >
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#fef3f2] text-[#b42318]">
            <FiAlertTriangle className="h-5 w-5" aria-hidden="true" />
          </div>

          <div className="min-w-0 flex-1">
            <h2
              id="confirm-dialog-title"
              className="font-[Merriweather] text-[1.125rem] text-[#130705]"
            >
              {title}
            </h2>
            {message ? (
              <p className="mt-2 text-sm leading-relaxed text-[#6b635c]">{message}</p>
            ) : null}
          </div>
        </div>

        <div className="mt-6 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rounded-md !border !border-[#e4d9c8] !bg-white px-4 py-2 text-[13px] font-medium !text-[#130705] !shadow-none transition hover:!bg-[#faf8f4] hover:!shadow-none disabled:opacity-60"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="rounded-md !border !border-[#fecdca] !bg-[#fef3f2] px-4 py-2 text-[13px] font-medium !text-[#b42318] !shadow-none transition hover:!border-[#fda29b] hover:!bg-[#fee4e2] hover:!shadow-none disabled:opacity-60"
          >
            {isLoading ? 'Deleting…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
